import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { leaveRoom } from '../services/GameService';
import SignalRService from '../services/SignalRService';
import { getErrorMessage } from '../services/ApiError';
import { clearRoomMembership } from '../services/RoomSession';
import { customStorage } from '../services/CommonService';
import { STO_PLAYER_ID, STO_ROOM_ID } from '../constants/commonConstants';

// Server membership must be updated while the session is still authenticated.
// Notification failure is recoverable through room polling; leave failure is not.
export const useRoomExit = ({ roomId, playerId, setLoading, setErrorMessage, setConfirmText, onRoomLeft, fallbackError, lobbyPath = '/poker' }) => {
    const { logout, logoutGuest, isGuest } = useAuth();
    const navigate = useNavigate();

    const exitRoom = async (shouldLogout) => {
        try {
            setLoading(true);
            await leaveRoom(roomId, playerId);
            try {
                await SignalRService.leaveRoom(roomId, playerId);
            } catch (error) {
                console.error('Failed to notify the room about leaving:', error);
            }
            clearRoomMembership(roomId);
            if (customStorage.getItem(STO_ROOM_ID) === roomId) {
                customStorage.removeItem(STO_ROOM_ID);
                customStorage.removeItem(STO_PLAYER_ID);
            }
            onRoomLeft();
            if (shouldLogout) {
                if (isGuest) await logoutGuest(); else await logout();
                navigate(isGuest ? '/' : '/login', { replace: true });
            } else {
                navigate(lobbyPath);
            }
        } catch (error) {
            setErrorMessage(getErrorMessage(error, fallbackError));
        } finally {
            if (!shouldLogout) setConfirmText('');
            setLoading(false);
        }
    };

    return {
        handleLeaveRoom: () => exitRoom(false),
        handleLogoutFromRoom: () => exitRoom(true),
    };
};
